<template>
  <div>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('accountWithdrawalApplyShManage.title') }}</span>
      </div>
      <div class="">
        <el-form :inline="true" :model="queryParams" class="flex justify-start">
          <el-form-item>
            <el-input v-model="queryParams.applyUserName"
              :placeholder="$t('accountWithdrawalApplyShManage.applyUserNamePlaceholder')" clearable
              @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="queryParams.applyUserTel"
              :placeholder="$t('accountWithdrawalApplyShManage.applyUserTelPlaceholder')" clearable
              @keyup.enter.native="handleQuery" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleQuery">
              {{ $t('accountWithdrawalApplyShManage.search') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>



    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('accountWithdrawalApplyShManage.withdrawalAudit') }}</span>
      </div>
      <el-table :data="tableData" border fit highlight-current-row style="width: 100%">
        <el-table-column prop="amount" :label="$t('accountWithdrawalApplyShManage.amount')" align="center" />
        <el-table-column prop="applyUserName" :label="$t('accountWithdrawalApplyShManage.applyUserName')"
          align="center" />
        <el-table-column prop="applyUserTel" :label="$t('accountWithdrawalApplyShManage.applyUserTel')"
          align="center" />
        <el-table-column prop="context" :label="$t('accountWithdrawalApplyShManage.context')" align="center" />
        <el-table-column prop="stateName" :label="$t('accountWithdrawalApplyShManage.state')" align="center" />
        <el-table-column :label="$t('accountWithdrawalApplyShManage.actions')" align="center" width="120">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleAudit(scope.row)">
              {{ $t('accountWithdrawalApplyShManage.audit') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>


      <el-pagination v-show="total > 0" :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.rows"
        @pagination="getList" />
    </el-card>


    <AccountWithdrawalApplyAudit ref="audit" :current-row="currentRow" @audit-success="handleAuditSuccess" />
  </div>
</template>

<script>
import { getWithdrawalApplyList } from '@/api/admin/accountWithdrawalApplyShManage/accountWithdrawalApplyShManageApi'
import AccountWithdrawalApplyAudit from '@/components/admin/AccountWithdrawalApplyAudit.vue'

export default {
  name: 'AccountWithdrawalApplyShManage',
  components: { AccountWithdrawalApplyAudit },
  data() {
    return {
      tableData: [],
      total: 0,
      queryParams: {
        page: 1,
        row: 10,
        state: '486',
        applyUserName: '',
        applyUserTel: ''
      },
      currentRow: null
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      getWithdrawalApplyList(this.queryParams).then(response => {
        this.tableData = response.data
        this.total = response.total
      })
    },
    handleQuery() {
      this.queryParams.page = 1
      this.getList()
    },
    handleAudit(row) {
      this.currentRow = row
      this.$refs.audit.open()
    },
    handleAuditSuccess() {
      this.getList()
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}
</style>